module.exports = __webpack_public_path__ + "static/media/donut-logo-text.68536f13.png";